import * as _ from 'lodash';
import { TableWrapperLeftAligned } from './styles';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    list: string[]
}

const CenterContactPositionsList = (props: IProps) => {
    const sortedList = props.list

    return (
        <div style={{ height: props.list.length < 10 ? null : 300, overflowY: 'auto' }}>
            <TableWrapperLeftAligned className='table table-condensed table-striped table-bordered'>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}>R#</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedList.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td>{ReactHtmlParser(item)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </TableWrapperLeftAligned>
        </div>
    );
}

export default CenterContactPositionsList;